App.controller('HealthInsuranceWithPaymentsStartCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$timeout', 'popUpService', function ($scope, $sce, $state, $http, packageService, $timeout, popUpService) {
    $scope.page = 'healthInsuranceWithPayments_start';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Opieka medyczna';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    $timeout(function() {
    	if (!$('.menu.menu_3c').hasClass('open')) {
    		$('a[target=".menu_3c"]').trigger('click');
    	}
    }, 0);

    popUpService.showPopUp({
        tpl: 'info-big', head: 'UWAGA',
        content: `W związku z decyzją operatora medycznego, program abonamentu zdrowotnego dla członków OIRP w&nbsp;LUX&nbsp;MED zostanie zakończony z końcem października.`
    });
}]);
